/* eslint-disable no-shadow */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { submitAcceptEngagement } from "../../actions/agencyProfileActions";
import Saving from "../shared/loaders/Saving";
import Button from "../shared/button/Button";
import trackEvent from "../shared/ga/trackEvent";
import logo from "../RequestEngagement/img/hh.png";
import "url-search-params-polyfill";
import {
  Wrapper,
  Inner,
  Message,
  Header,
  About,
  Avatar,
  Name,
  Agency,
  Actions,
  OpenButton,
  CloseButton,
} from "./styles/agency-message-styles";

export class AgencyMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: true,
    };
  }

  toggleMessage = () => {
    this.setState(({ isExpanded }) => ({
      isExpanded: !isExpanded,
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { submitAcceptEngagement, engagementId, employerUserId, jobId } =
      this.props;

    trackEvent("engagements", "agency profile", "accept");
    submitAcceptEngagement({ engagementId, employerUserId, jobId });
  };

  render() {
    const {
      toggleRejectModal,
      acceptEngagementLoading,
      engagementMessageData,
    } = this.props;
    const { isExpanded } = this.state;

    return (
      <Wrapper>
        {acceptEngagementLoading && <Saving grey mediumFont noText />}
        <Inner>
          <Header>
            <About>
              <Avatar src={logo} alt="Avatar" data-test-id="avatar" />
              <Name data-test-id="agent-name">
                {engagementMessageData.agentName},
              </Name>
              <Agency data-test-id="agency-name">
                {engagementMessageData.agencyName}
              </Agency>
              {!isExpanded && (
                <OpenButton onClick={this.toggleMessage}>
                  <FontAwesomeIcon icon={faChevronDown} />
                </OpenButton>
              )}
            </About>
            <Actions>
              <Button
                secondary
                buttonName="Reject"
                onClickAction={() => toggleRejectModal()}
                dataTestId="reject-button"
              />
              <Button
                primary
                buttonName="Accept"
                onClickAction={(e) => this.handleSubmit(e)}
                dataTestId="accept-button"
              />
            </Actions>
          </Header>
          {isExpanded && (
            <Message data-test-id="message">
              &quot;{engagementMessageData.message}&quot;
              <CloseButton onClick={this.toggleMessage}>
                <FontAwesomeIcon icon={faChevronUp} />
              </CloseButton>
            </Message>
          )}
        </Inner>
      </Wrapper>
    );
  }
}

AgencyMessage.propTypes = {
  engagementId: PropTypes.number,
  toggleRejectModal: PropTypes.func.isRequired,
  submitAcceptEngagement: PropTypes.func.isRequired,
  acceptEngagementLoading: PropTypes.bool.isRequired,
  employerUserId: PropTypes.string.isRequired,
  jobId: PropTypes.number.isRequired,
  engagementMessageData: PropTypes.shape({
    agentName: PropTypes.string,
    agencyName: PropTypes.string,
    message: PropTypes.string,
    avatar: PropTypes.string,
  }),
};

AgencyMessage.defaultProps = {
  engagementId: PropTypes.isNull,
  engagementMessageData: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  engagementMessageData: state.agencyProfile.profileData.engagementMessageData,
  acceptEngagementLoading: state.agencyProfile.acceptEngagementLoading,
});

export default connect(mapStateToProps, { submitAcceptEngagement })(
  AgencyMessage
);
